import React from "react";
import FormField from "./FormField";

export default function TextAreaField({
  id,
  name,
  label,
  value,
  onChange,
  placeholder,
  error,
  styles,
  className,
}) {
  return (
    <FormField label={label} htmlFor={id} error={error} styles={styles} className={className || styles?.inputGroup}>
      <textarea
        id={id}
        name={name}
        value={value}
        onChange={onChange}
        placeholder={placeholder}
        className={`${styles?.textarea || ""} ${error ? styles?.inputError : ""}`.trim()}
      />
    </FormField>
  );
}
